<template>
  <div
    :class="{
      'show-sidebar': showSidebar,
      'hide-sidebar': !showSidebar,
      paf: $root.user && $root.user.realm === 'PAF',
      'balcao-mais':
        $root.user && $root.user.realm !== 'PAF' && $root.user.hasBalcaoMais,
    }"
  >
    <BlockUI :blocked="hasMissingData">
      <!--Navbar-->
      <div
        class="
          layout-wrapper layout-static layout-menu-light layout-topbar-blue
        "
      >
        <div
          class="layout-topbar"
          :class="{
            'layout-topbar-paf': $root.user && $root.user.realm === 'PAF',
            'layout-topbar-balcao-mais':
              $root.user &&
              $root.user.realm !== 'PAF' &&
              $root.user.hasBalcaoMais,
          }"
        >
          <button
            class="p-link layout-menu-button layout-topbar-icon"
            @click="setShowSidebar"
          >
            <i class="pi pi-bars" />
          </button>
          <router-link
            :to="{ name: 'dashboard' }"
            class="layout-topbar-logo inline"
          >
            <img
              :src="
                $root.user.realm === 'PAF'
                  ? $root.images.pafLogoWhite
                  : $root.user.hasBalcaoMais
                  ? $root.images.balcaoMaisLogo
                  : $root.images.beLogoTransparentBackground
              "
              alt="logo"
              class=""
            />
          </router-link>

          <ul class="topbar-menu">
            <li>
              <button class="p-link layout-topbar-icon" @click="confirmLogout">
                <i class="topbar-icon pi pi-fw pi-sign-out" />
              </button>
              <ConfirmDialog
                group="headless"
                :header="$t('logout_header')"
              ></ConfirmDialog>
            </li>
            <li v-if="$root.user.isClient">
              <button
                class="p-link layout-topbar-icon mr-1"
                @click="visibleProfile = true"
              >
                <i class="topbar-icon pi pi-fw pi-user" />
              </button>
            </li>
            <li v-if="$root.user.isClient">
              <button
                class="p-link layout-topbar-icon"
                @click="visibleNotifications = true"
              >
                <span class="p-overlay-badge">
                  <i class="topbar-icon pi pi-fw pi-bell" />
                  <span id="numberOfNotifications" class="p-badge">
                    {{ numberOfNotifications }}
                  </span>
                </span>
              </button>
            </li>
            <li>
              <PwaInstallButton v-if="$root.user.isClient" />
            </li>
            <!-- <li class="navbar-user-name p-d-none p-d-md-inline-flex">
            {{ $root.user.name }}
          </li> -->
          </ul>
        </div>
        <Sidebar
          v-model:visible="showSmSidebar"
          :show-close-icon="false"
          class="layout-menu-container-sidebar"
          position="left"
          style="width: 250px"
          @hide="resetShowSidebar"
        >
          <DashboardSidebarMenu
            :contacts="contacts"
            @router-changed="resetShowSidebar"
          />
          <!--
          <SidebarClient />
          -->
        </Sidebar>
        <div class="layout-menu-container">
          <DashboardSidebarMenu :contacts="contacts" />
        </div>
        <div class="layout-main">
          <div class="layout-content">
            <div class="layout-dashboard">
              <Message
                v-if="hasCardPaymentAlert"
                severity="warn"
                @close="setHasCardPaymentAlert()"
                v-text="$t('warn_pay_balcao_pending')"
              />
              <section>
                <div
                  v-if="currentRouteName === 'dashboard'"
                  class="card-align-posts dashboard-home"
                >
                  <div v-if="$root.user.isClient" class="dashboard-home-grid">
                    <div
                      class="
                        dashboard-home-grid__posts
                        p-2
                        pt-0
                        sm:p-3 sm:pt-0
                        lg:p-6 lg:pt-0
                      "
                    >
                      <header class="dashboard-home__hero">
                        <h2 class="dashboard-home__welcome">
                          {{ $t("welcome_message", { name: $root.user.name }) }}
                        </h2>
                      </header>
                      <Posts />
                    </div>
                    <aside
                      class="dashboard-home-grid__middle"
                      aria-label="Agendamentos e documentação"
                    >
                      <DashboardAgendaHub
                        :has-balcao-mais="$root.user.hasBalcaoMais"
                      />
                      <DocumentationOverview
                        compact
                        hide-when-empty
                        class="dashboard-home__documentation"
                        :main-people="documentationMainPeople"
                        :family-people="documentationFamilyPeople"
                        :family-is-relation="false"
                        family-show-in-client-relations
                      />
                    </aside>
                    <aside
                      class="dashboard-home-grid__news"
                      aria-label="Destaques e notícias"
                    >
                      <DashboardSidebarWidgets
                        class="dashboard-home__widgets"
                      />
                      <News :exclusive-content="$root.user.hasBalcaoMais" />
                      <ShowLastBussola
                        v-if="$root.user.hasBalcaoMais"
                        class="dashboard-home__rail-block"
                      />
                    </aside>
                  </div>
                  <div v-else class="p-2 sm:p-3 lg:p-6 lg:pt-0">
                    <h2>
                      {{ $t("welcome_message", { name: $root.user.name }) }}
                    </h2>
                  </div>
                </div>
                <div
                  v-else
                  :class="[
                    currentRouteName == 'post' ? 'card-align-posts' : 'post',
                    currentRouteName == 'process' ? 'card' : null,
                  ]"
                >
                  <router-view />
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Notifications
        v-if="$root.user.isClient"
        :visible="visibleNotifications"
        @sidebar-closed="visibleNotifications = false"
        @number-of-notifications-changed="setNotificationsNumber"
      />
      <EditProfile
        v-if="$root.user.isClient"
        :visible="visibleProfile"
        @sidebar-closed="visibleProfile = false"
      />
      <Toast :auto-z-index="false" />
    </BlockUI>
    <AddMissingData
      v-if="$root.user.isClient && hasMissingData"
      :visible="hasMissingData"
      @dialog-closed="hasMissingData = false"
    />
    <PushNotificationPrompt
      v-if="$root.user.isClient"
      :visible="pushPromptVisible"
      :activating="pushPromptActivating"
      @activate="onPushPromptActivate"
      @dismiss="onPushPromptDismiss"
    />
  </div>
</template>

<script>
import BlockUI from "primevue/blockui";
import Posts from "../posts/Posts.vue";
import EditProfile from "../profile/EditProfile.vue";
import Notifications from "../profile/Notifications.vue";
import AddMissingData from "./AddMissingData.vue";
import DashboardAgendaHub from "./DashboardAgendaHub.vue";
import DashboardSidebarMenu from "./DashboardSidebarMenu.vue";
import DashboardSidebarWidgets from "./DashboardSidebarWidgets.vue";
import ShowLastBussola from "../bussola/ShowLastBussola.vue";
import DocumentationOverview from "../clientDocumentations/DocumentationOverview.vue";
import News from "../news/News.vue";
import Message from "primevue/message";
import ConfirmDialog from "primevue/confirmdialog";
import PushNotificationPrompt from "../profile/PushNotificationPrompt.vue";
import PwaInstallButton from "../pwa/PwaInstallButton.vue";
import {
  dismissPushPrompt,
  shouldOfferPushNotifications,
} from "../../utils/pushNotificationPrompt";
import {
  isPushSupported,
  setPushOptInPreference,
  subscribeToPush,
} from "../../utils/pushNotifications";
import { translateRelationToPt } from "../../utils/translateRelation";

export default {
  components: {
    ConfirmDialog,
    EditProfile,
    Notifications,
    Posts,
    DashboardAgendaHub,
    DashboardSidebarMenu,
    BlockUI,
    AddMissingData,
    DashboardSidebarWidgets,
    ShowLastBussola,
    DocumentationOverview,
    News,
    Message,
    PushNotificationPrompt,
    PwaInstallButton,
  },
  data() {
    return {
      visibleNotifications: false,
      numberOfNotifications: 0,
      visibleProfile: false,
      showSidebar: true,
      showSmSidebar: false,
      contacts: [],
      documentationFamilyPeople: [],
      hasMissingData: false,
      hasCardPaymentAlert: false,
      pushPromptVisible: false,
      pushPromptActivating: false,
      pushPromptCheckScheduled: false,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    documentationMainPeople() {
      const user = this.$root.user;
      if (!user || !user.id) {
        return [];
      }
      return [{ id: user.id, name: user.name, imgUrl: user.imgUrl }];
    },
  },
  watch: {
    "$store.state.pushNotificationsEnabled"(enabled) {
      if (enabled) {
        this.pushPromptVisible = false;
      } else if (this.$root.user.isClient) {
        this.schedulePushPromptCheck();
      }
    },
  },
  created() {
    if (this.$root.user.isClient) {
      this.getHasMissingData();
      this.loadDocumentationFamilyPeople();
    }
    if (
      this.$root.user.isClient &&
      (!this.contacts || this.contacts.length === 0)
    ) {
      this.$root
        .apiGet(this.$root.api.profile, { params: { dataType: "contacts" } })
        .then((response) => {
          this.contacts = response.data.data;
        })
        .catch((error) => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.msg_code == "client_not_found"
          ) {
            this.$root.logout();
          } else {
            this.$root.toastError(error.response.data.msg_code);
          }
        });
    }
  },
  mounted() {
    if (this.$root.user.isClient) {
      this.getHasCardPaymentAlert();
      this.loadPushNotificationsPreference().finally(() => {
        this.schedulePushPromptCheck();
      });
    }
    if (!!this.$root.user.hasBalcaoMais && !this.$root.user.cardImageUrl) {
      this.setCardImageUrl();
    }
  },
  methods: {
    setNotificationsNumber(number) {
      if (!isNaN(number)) {
        this.numberOfNotifications = number;
      }
    },
    loadDocumentationFamilyPeople() {
      const clientId = this.$root.user && this.$root.user.id;
      if (!clientId) {
        return;
      }

      this.$root
        .apiGet(this.$root.api.clientRelations, {
          params: { clientId },
        })
        .then((response) => {
          const list = (response.data && response.data.data) || [];
          const seen = new Set();
          this.documentationFamilyPeople = list
            .map((relation) => {
              const id = relation.childClientId;
              const name = relation.childClientName;
              if (!id || !name || id === clientId || seen.has(id)) {
                return null;
              }
              seen.add(id);
              return {
                id,
                name,
                relationLabel: translateRelationToPt(relation.relationship),
              };
            })
            .filter(Boolean);
        })
        .catch(() => {
          this.documentationFamilyPeople = [];
        });
    },
    loadPushNotificationsPreference() {
      return this.$root
        .apiGet(this.$root.api.profile, { params: { dataType: "form" } })
        .then((response) => {
          this.$store.commit(
            "setPushNotificationsEnabled",
            response.data.data.pushNotificationsEnabled || false
          );
        })
        .catch(() => {});
    },
    schedulePushPromptCheck(delayMs = 1500) {
      if (
        this.pushPromptCheckScheduled ||
        !this.$root.user.isClient ||
        !isPushSupported()
      ) {
        return;
      }
      this.pushPromptCheckScheduled = true;
      window.setTimeout(() => {
        this.pushPromptCheckScheduled = false;
        this.checkPushPrompt();
      }, delayMs);
    },
    async checkPushPrompt() {
      if (!this.$root.user.isClient) {
        this.pushPromptVisible = false;
        return;
      }

      const offer = await shouldOfferPushNotifications(
        this.$root.apiGet.bind(this.$root),
        this.$root.api.pushVapidPublicKey,
        this.$store.state.pushNotificationsEnabled
      );
      this.pushPromptVisible = offer;
    },
    async onPushPromptActivate() {
      if (this.pushPromptActivating) {
        return;
      }
      this.pushPromptActivating = true;
      try {
        const result = await subscribeToPush(
          this.$root.apiGet.bind(this.$root),
          this.$root.apiPost.bind(this.$root),
          this.$root.api.pushVapidPublicKey,
          this.$root.api.pushSubscribe
        );

        if (result === "granted") {
          setPushOptInPreference(true);
          this.$store.commit("setPushNotificationsEnabled", true);
          this.pushPromptVisible = false;
        } else if (result === "denied") {
          dismissPushPrompt();
          this.pushPromptVisible = false;
        } else if (result === "server-unavailable") {
          this.$root.toastWarning(this.$t("push_notifications_unavailable"));
        } else {
          this.$root.toastWarning(this.$t("push_notifications_unsupported"));
        }
      } finally {
        this.pushPromptActivating = false;
      }
    },
    onPushPromptDismiss() {
      dismissPushPrompt();
      this.pushPromptVisible = false;
    },
    setShowSidebar() {
      this.showSidebar = !this.showSidebar;
      if (document.body.offsetWidth < 1136) {
        this.showSmSidebar = true;
        this.showSidebar = false;
      }
    },
    resetShowSidebar() {
      this.showSmSidebar = false;
      this.showSidebar = true;
    },
    getHasMissingData() {
      this.$root
        .apiGet(this.$root.api.hasMissingData)
        .then((response) => {
          this.hasMissingData = response.data.data;
        })
        .catch((error) => {
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    getHasCardPaymentAlert() {
      this.$root.apiGet(this.$root.api.hasCardPaymentAlert).then((response) => {
        if (response.data.data) {
          this.hasCardPaymentAlert = true;
        }
      });
    },
    setHasCardPaymentAlert() {
      this.hasCardPaymentAlert = false;
      this.$root.apiPut(this.$root.api.hasCardPaymentAlert, {
        hasCardPaymentAlert: false,
      });
    },
    setCardImageUrl() {
      this.$root
        .apiPost(this.$root.api.cardImageUrl)
        .then(() =>
          this.$root.apiGet(this.$root.api.jwt).then((response) => {
            const jwt = response.data.data;
            if (jwt) {
              this.$store.commit("setToken", jwt);
              this.$root.axiosSetAuth(jwt, false);
            }
          })
        )
        .catch((error) => {
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    confirmLogout() {
      this.$confirm.require({
        group: "headless",
        header: this.$t("logout_header"),
        message: this.$t("logout_message"),
        rejectLabel: this.$t("bt_no"),
        acceptLabel: this.$t("bt_yes"),
        icon: "pi pi-question",
        acceptClass: "p-button p-component ml-2",
        rejectClass:
          "p-button p-component p-button-secondary p-button-outlined",
        accept: () => {
          this.$root.logout(); // Chama o método de logout se o usuário confirmar
        },
        reject: () => {
          //this.$root.toastSuccess("");
        },
      });
    },
  },
};
</script>
